import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { useStudyStreak } from 'modules/studyStreak/useStudyStreak';

const MIN_BAR_PX = 8;
const MAX_BAR_PX = 116;

/** The last 7 days of focus minutes as bars, today last and lime. Renders nothing until the streak loads. */
export function HomeWeek() {
  const { t, i18n } = useTranslation();
  const { data } = useStudyStreak();
  if (!data) return null;

  const week = data.days.slice(-7);
  const total = week.reduce((sum, day) => sum + day.focusMinutes, 0);
  const peak = Math.max(1, ...week.map((day) => day.focusMinutes));
  const hours = Math.floor(total / 60);
  const minutes = total % 60;
  const label = hours > 0 ? t('portal.duration_hm', { h: hours, m: minutes }) : t('portal.duration_m', { m: minutes });

  return (
    <section aria-labelledby="home-week-title" className="rounded-[20px] border border-border bg-card p-5 md:p-6">
      <div className="flex items-baseline justify-between gap-3">
        <h2 id="home-week-title" className="font-display text-lg font-extrabold tracking-[-0.03em] text-foreground">
          {t('portal.week_title')}
        </h2>
        <span className="text-[13px] font-bold tabular-nums text-foreground">{label}</span>
      </div>
      <p className="mt-1 text-[13px] text-muted-foreground">{t('portal.week_streak', { count: data.current })}</p>
      <ol className="mt-4 flex h-[140px] items-end gap-2.5 md:gap-3">
        {week.map((day, index) => {
          const today = index === week.length - 1;
          const height = MIN_BAR_PX + Math.round((day.focusMinutes / peak) * (MAX_BAR_PX - MIN_BAR_PX));
          return (
            <li key={day.date} className="flex flex-1 flex-col items-center gap-2">
              <span
                role="img"
                aria-label={t('portal.duration_m', { m: day.focusMinutes })}
                style={{ height }}
                className={cn(
                  'w-full max-w-[34px] rounded-t-lg rounded-b-[4px]',
                  today ? 'bg-primary shadow-[inset_0_0_0_1.5px_rgba(16,24,43,0.18)]' : 'bg-border',
                )}
              />
              <span className="text-[11.5px] font-semibold text-muted-foreground">
                {new Date(`${day.date}T12:00:00Z`).toLocaleDateString(i18n.language, { weekday: 'short', timeZone: 'UTC' }).slice(0, 2)}
              </span>
            </li>
          );
        })}
      </ol>
    </section>
  );
}

export default HomeWeek;
